<template>
    <div class="error">
        <!-- <img :src="icon" alt=""> -->
        <span class="nofound">404</span>
        <span>输入的网址不正确或服务已过期</span>
    </div>
</template>
<script>
export default {
    data() {
        return {
            icon: require('@/assets/icon/notdata.png')
        }
    },
}
</script>
<style scoped>
.error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #73b0e9;
    font-size: 25px;
    font-weight: 600;
    font-family: monospace;
    background-color: #9cc3ed;
    user-select: none;
}
.error .nofound {
    font-size: 450px;
    line-height: 1;
    margin: 10px;
    background-clip: text;
    -webkit-background-clip: text;
}
</style>


// WEBPACK FOOTER //
// src/components/error.vue